<template>
	<div>
		<div class="display-flex flex-direction-column align-items-center">
			<LottieAnimation
				:lottie-file="lottieFileUrl"
				:loop="false"
				:max-retries="2"
				autoplay-behavior="ON_LOAD"
				@on-complete="emit('onComplete')"
				@on-fail="emit('onFail')"
			/>
			<h1 class="body-lg text-color-content-secondary font-weight-bold text-align-center"
				>Your Fundrise account was created successfully</h1
			>
		</div>
	</div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import LottieAnimation from '@components/layout/lottie-animation.vue';

const emit = defineEmits(['onComplete', 'onFail']);

const lottieFileUrl = `${appCloudfrontPath}/video/lottie-json/hd-checkmark.json`;
</script>
